import React from 'react';
import { ArcText } from '@src/core/ui';
import { IAuthFormHeaderProps } from './types';

const AuthFormHeader: React.FC<IAuthFormHeaderProps> = ({ title, subtitle }) => {
  return (
    <>
      <ArcText.h3 textAlign='center'>{title}</ArcText.h3>
      <ArcText.caption mt={0.5} fontSize={16} textAlign='center'>{subtitle}</ArcText.caption>
    </>
  );
};

export default AuthFormHeader;

